<template>
    <div component="ProjectVideoListDialogItem" @click.stop="$emit('play', video)">
        <div class="index">{{ index }}</div>
        <div class="name">
            {{ video.video_name }}
        </div>
        <btn
            :icon="'file_download'"
            :size="'iconSmall'"
            color="transparent"
            @click.stop="$emit('download', video, index)"
            :state="!isPlayable(video) ? 'load' : ''"
            :class="{ hidden: !isPlayable(video) }"
        />
        <btn
            :icon="'close'"
            :size="'iconSmall'"
            color="transparent"
            @click.prevent="removeConfirm = true"
            :state="!isPlayable(video) ? 'load' : ''"
        />
        <div class="warning" :class="{ show: removeConfirm }">
            <div class="label">Remove video?</div>
            <btn :icon="'close'" color="ghost" :size="'iconSmall'" @click.stop="removeConfirm = false" />
            <btn :icon="'check'" color="ghost" :size="'iconSmall'" @click.stop="$emit('remove', video)" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from '~/vuex';

export default {
    name: 'ProjectVideoListDialogItem',
    props: ['index', 'video'],

    data() {
        return {
            removeConfirm: false,
            uplaoded: true,
        };
    },

    computed: {
        isPlayable(video) {
            return (video) => !!video.converted_at;
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ProjectVideoListDialogItem'] {
    position: relative;
    .flex-row;
    justify-content: space-between;
    .border-t;
    padding: 5px 10px;
    width: 100%;
    cursor: pointer;
    transition: 0.5s;
    min-height: 35px;
    overflow: hidden;

    &.selected {
        background: fade(@black, 8%);
    }

    &:hover {
        background: fade(@black, 3%);
    }

    .index {
        padding-right: 5px;
        font-weight: 600;
    }

    .name {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .warning {
        .flex-row;
        justify-content: flex-end;
        position: absolute;
        right: 0;
        height: 100%;
        width: 100%;
        z-index: 6;
        transition: 0.3s;
        transform: translateX(110%);
        padding: 10px 10px 10px 30px;
        background: @white !important;

        &.show {
            transform: translateX(0);
        }

        .label {
            font-weight: 700;
            margin-right: 10px;
        }

        button {
            margin-left: 3px;
        }
    }

    .hidden {
        opacity: 0;
    }

    &:not(.uploaded) {
        pointer-events: none;
        cursor: progress;
    }
}
</style>
